<template>
  <section class="h-48 overflow-auto shadow-2xl bg-white rounded-lg p-4">
    <div class="w-full">
      <div
        v-for="(item, index) in exchangeRateSelectionArray"
        :key="index"
        :class="
          !isExchangeable(item)
            ? 'cursor-not-allowed opacity-20'
            : 'cursor-pointer'
        "
        v-on="
          isExchangeable(item) ? { click: () => setExchangeRate(item) } : {}
        "
        class="mb-2"
      >
        <el-tooltip
          class="item"
          effect="dark"
          :disabled="isExchangeable(item)"
          :content="getExchangeRateDetail(item)"
          placement="right"
        >
          <div
            class="flex justify-between items-center px-3 py-2"
            :class="
              (isSourceCurrency && country.currency === item) ||
              (!isSourceCurrency && country2.currency === item)
                ? 'bg-bg-muted rounded-lg'
                : ''
            "
          >
            <div class="flex gap-x-4">
              <currency-icons
                :currency="getCurrencyCountry(item)"
                size="w-5 h-5"
              />
              <div>
                <p class="text-sm font-bold text-root-2 capitalize">
                  {{ item }}
                </p>
              </div>
              <small-check
                v-if="
                  (isSourceCurrency && country.currency === item) ||
                  (!isSourceCurrency && country2.currency === item)
                "
              />
            </div>
          </div>
        </el-tooltip>
      </div>
    </div>
  </section>
</template>
<script>
import { GetCurrencyCountry, ParseMoneyAll } from '@/utils/helpers.js'
import tenant from '@/mixins/tenant.js'
import exchangeRateBase from '@/mixins/localDeposit.js'
import getTransferDetail from '@/mixins/terminal.js'
export default {
  props: {
    currencyType: {
      type: String,
      default: ''
    }
  },
  mixins: [tenant, exchangeRateBase, getTransferDetail],
  components: {
    CurrencyIcons: () => import('@/assets/icons/CurrencyIcons.vue'),
    SmallCheck: () => import('@/assets/v2/icons/SmallCheck.vue')
  },
  methods: {
    getCurrencyCountry (val) {
      return GetCurrencyCountry(val)
    },
    parseMoneyAll (amount, currency) {
      return ParseMoneyAll(amount, currency)
    },
    setExchangeRate (currency, type) {
      const sourceCurrency = this.isSourceCurrency
        ? currency
        : this.activeCurrency
      const targetCurrency = this.isSourceCurrency
        ? this.secondaryCurrency
        : currency

      const details = this.transferDetails.find(
        (detail) =>
          (this.isSourceCurrency
            ? detail.from === currency && detail.to === this.secondaryCurrency
            : detail.from === this.activeCurrency && detail.to === currency) ||
          (this.isSourceCurrency
            ? detail.from === targetCurrency && detail.to === sourceCurrency
            : detail.from === sourceCurrency && detail.to === targetCurrency)
      )

      if (!details || !details.is_enabled) {
        if (currency === targetCurrency) {
          const activeCurrency = this.activeCurrency
          const secondaryCurrency = this.secondaryCurrency
          this.$store.dispatch(
            'common/setActiveCurrency',
            this.isSourceCurrency ? currency : secondaryCurrency
          )
          this.$store.dispatch(
            'common/setSecondaryCurrency',
            this.isSourceCurrency ? activeCurrency : currency
          )
          const exchangedDetails = this.transferDetails.find(
            (detail) =>
              (this.isSourceCurrency
                ? detail.from === currency &&
                  detail.to === this.secondaryCurrency
                : detail.from === this.activeCurrency &&
                  detail.to === currency) ||
              (this.isSourceCurrency
                ? detail.from === this.secondaryCurrency &&
                  detail.to === currency
                : detail.from === currency && detail.to === this.activeCurrency)
          )

          if (!exchangedDetails.is_enabled) {
            this.getNextAvailableCurrencyOption(currency)
          }
        } else {
          this.getNextAvailableCurrencyOption(currency)
        }
      } else {
        this.$store.dispatch(
          this.isSourceCurrency
            ? 'common/setActiveCurrency'
            : 'common/setSecondaryCurrency',
          currency
        )
      }
      this.$emit('clearInput')
      this.$emit('closeAccountSelection')
    },
    isExchangeable (currency, type) {
      const isAsset = type === 'asset'
      const sameCurrency = this.isSourceCurrency
        ? currency === this.secondaryCurrency
        : currency === this.activeCurrency
      const details = this.transferDetails.find((detail) =>
        this.isSourceCurrency
          ? detail.from === currency && detail.to === this.secondaryCurrency
          : detail.from === this.activeCurrency && detail.to === currency
      )
      if (isAsset && this.isSourceCurrency) {
        return false
      }
      if (sameCurrency) {
        return true
      }
      return this.isSourceCurrency || details?.is_enabled
    },
    getExchangeRateDetail (currency, type) {
      const details = this.transferDetails.find((detail) =>
        this.isSourceCurrency
          ? detail.from === currency && detail.to === this.secondaryCurrency
          : detail.from === this.activeCurrency && detail.to === currency
      )
      const sameCurrency = this.isSourceCurrency
        ? currency === this.secondaryCurrency
        : currency === this.activeCurrency
      if (!sameCurrency) {
        if (!details) {
          return `${
            this.isSourceCurrency ? currency : this.activeCurrency
          } to ${
            this.isSourceCurrency ? this.secondaryCurrency : currency
          } rate not available`
        }
        if (!details.is_enabled && !this.isSourceCurrency) {
          return `${this.activeCurrency} to ${this.secondaryCurrency} rate not available`
        }
      }
    }
  },
  computed: {
    isSourceCurrency () {
      return this.currencyType === 'source'
    },
    transferDetails () {
      return this.$store.state.auth.transferDetails
    }
  }
}
</script>
<style scoped>
.box {
  box-shadow: 0px 8px 16px 0px #0302071a;
  box-shadow: 0px 0px 1px 0px #0302071a;
}
</style>
